import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardFooter, CardTitle, Table } from "reactstrap";
import VWPagination from "../../components/vwPagination/vwPagination";
import NoRecord from "../../components/NoRecords/noRecords";
import VWLoading from "../../components/vwLoading/vwLoading";
import {
    clearAppVersionListError,
    closeCreateAppVersionModal,
    closeUpdateAppVersionModal,
    getAppVersionList,
    openCreateAppVersionModal,
    openUpdateAppVersionModal,
    setAppVersionDetails
} from "../../store/appVersion/actions";
import { getPager } from "../../helper/common";
import moment from "moment";
import Skeleton from '../../components/vwSkeleton/vwSkeleton'
import VWModel from "../../components/vwModal/vwModal";
import AddAppVersion from "./AddAppVersion";
import EditAppVersion from "./EditAppVersion";
import Message from "../../CommonData/Data/Message";

const style = {
    table: {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'separate',
    },
    th: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'sticky',
        backgroundColor: '#fff',
    },
};

const AppVersionList = (props) => {
    const { appVersionList, isAppVersionListPending, isAppVersionCreateModalOpen, isAppVersionEditModalOpen, totalRecords, errorMessage } = props;
    const [pageSize, setPageSize] = useState(10);
    const [pager, setPager] = useState({ currentPage: 1 });
    const [filter, setFilter] = useState();

    ///-----------------------FILTER------------------------------------------------
    const buildQueryVersionNo = () => {
        const { versionNo } = filter || {};
        let searchVersionNo = '';
        if (versionNo) {
            searchVersionNo += `${versionNo}`;
        }
        return searchVersionNo
    }
    const buildQueryNotes = () => {
        const { notes } = filter || {};
        let searchNotes = '';
        if (notes) {
            searchNotes += `${notes}`;
        }
        return searchNotes
    }
    const buildQueryReleasedDate = () => {
        const { releasedDate } = filter || {};
        let searchReleasedDate = '';
        if (releasedDate) {
            searchReleasedDate += `${releasedDate}`;
        }
        return searchReleasedDate
    }
    const buildQueryCreatedBy = () => {
        const { createdBy } = filter || {};
        let searchCreatedBy = '';
        if (createdBy) {
            searchCreatedBy += `${createdBy}`;
        }
        return searchCreatedBy
    }
    const buildQueryCreatedDateTime = () => {
        const { createdDateTime } = filter || {};
        let searchCreatedDateTime = '';
        if (createdDateTime) {
            searchCreatedDateTime += `${createdDateTime}`;
        }
        return searchCreatedDateTime
    }
    const buildQueryUpdatedBy = () => {
        const { updatedBy } = filter || {};
        let searchUpdatedBy = '';
        if (updatedBy) {
            searchUpdatedBy += `${updatedBy}`;
        }
        return searchUpdatedBy
    }
    const buildQueryUpdatedDateTime = () => {
        const { updatedDateTime } = filter || {};
        let searchUpdatedDateTime = '';
        if (updatedDateTime) {
            searchUpdatedDateTime += `${updatedDateTime}`;
        }
        return searchUpdatedDateTime
    }

    const setPage = (page = 1) => {
        props.getAppVersionList(page, pageSize, buildQueryVersionNo(), buildQueryNotes(), buildQueryReleasedDate(), buildQueryCreatedBy(),
            buildQueryCreatedDateTime(), buildQueryUpdatedBy(), buildQueryUpdatedDateTime(), sortDirection, sortOrder);
        setPager(prevPager => {
            const totalPages = Math.ceil(props.totalRecords / pageSize);
            const visiblePages = 5;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            };
        });
    };

    useEffect(() => {
        const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
        setPager(currentUpdatePager);
        props.clearAppVersionListError();
    }, [totalRecords, pageSize]);

    useEffect(() => {
        setPage();
    }, [pageSize])

    //-----------------------SORTING------------------------------------------------
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    useEffect(() => {
        if (sortOrder && sortDirection) {
            setPage();
        }
    }, [sortOrder, sortDirection])

    //--------------------------Create-------------------------------
    const handleOpenCreate = () => {
        props.openCreateAppVersionModal();
    };

    const handleCloseCreate = () => {
        props.closeCreateAppVersionModal();
    };

    //--------------------------Edit---------------------------------
    const handleOpenEdit = (id) => {
        const { openUpdateAppVersionModal, setAppVersionDetails } = props;
        const selected_version = appVersionList.find((version) => {
            return version.id === id;
        });
        setAppVersionDetails(selected_version);
        openUpdateAppVersionModal();
    };

    const handleEditClose = () => {
        props.closeUpdateAppVersionModal();
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Card>
                    <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
                        APP VERSIONS
                        <Link
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={handleOpenCreate}
                        >
                            <em className="fas fa-plus me-2"></em> Create App Version
                        </Link>
                    </CardTitle>
                </Card>
                <Card className='p-4'>
                    {errorMessage && (
                        <Message type="danger" defaultMessage={errorMessage} baseClassName="alert" />
                    )}
                    <div style={{ maxHeight: "500px", overflowX: "auto" }}>
                        <Table className="table table-hover table-nowrap w-100" size="sm" style={style.table}>
                            <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: '10' }}>
                                <tr>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('versionNo')}>
                                        VERSION NO
                                        {sortOrder === 'versionNo' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th>NOTES</th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('releasedDate')}>
                                        RELEASED ON
                                        {sortOrder === 'releasedDate' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdBy')}>
                                        CREATED BY
                                        {sortOrder === 'createdBy' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                                        CREATED ON
                                        {sortOrder === 'createdDateTime' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedBy')}>
                                        UPDATED BY
                                        {sortOrder === 'updatedBy' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedDateTime')}>
                                        UPDATED ON
                                        {sortOrder === 'updatedDateTime' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'} pe-2`} />)}
                                    </th>
                                    <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                                        ACTION
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {(appVersionList && appVersionList.length > 0) && !isAppVersionListPending ?
                                    appVersionList.map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.versionNo || "NA"}</td>
                                            <td>{data.notes || "NA"}</td>
                                            <td>{data.releasedDate ? moment(data.releasedDate).format("DD MMM YYYY") : "NA"}</td>
                                            <td>{data.createdBy || "NA"}</td>
                                            <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                                            <td>{data.updatedBy || "NA"}</td>
                                            <td>{data.updatedDateTime ? moment(data.updatedDateTime).format("DD MMM YYYY") : "NA"}</td>
                                            <td className="text-center sticky-column bg-white">
                                                <Link
                                                    className="btn btn-sm btn-light"
                                                    onClick={() => handleOpenEdit(data.id)}
                                                >
                                                    <em className="fa fa-edit"></em>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                    : isAppVersionListPending ?
                                        <tr>
                                            <td colSpan={9} align="center" className="p-4">
                                                <Skeleton type="body" />
                                                <VWLoading />
                                            </td>
                                        </tr>
                                        :
                                        <tr>
                                            <td colSpan={9}>
                                                <NoRecord />
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </Table>
                    </div>
                    <CardFooter>
                        {appVersionList && appVersionList.length > 0 ?
                            <VWPagination
                                pager={pager}
                                setPage={setPage}
                                totalRecords={totalRecords}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                            /> : null
                        }
                    </CardFooter>
                </Card>
            </div>

            <VWModel
                header="ADD APP VERSION INFO"
                isOpen={isAppVersionCreateModalOpen}
                handleClose={handleCloseCreate}
            >
                <AddAppVersion handleClose={handleCloseCreate} />
            </VWModel>
            <VWModel
                header="EDIT APP VERSION INFO"
                isOpen={isAppVersionEditModalOpen}
                handleClose={handleEditClose}
            >
                <EditAppVersion handleClose={handleEditClose} />
            </VWModel>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    //--------------------------List---------------------------------
    appVersionList: state.appVersion.appVersionList,
    totalRecords: state.appVersion.totalRecords,
    isAppVersionListPending: state.appVersion.isAppVersionListPending,
    errorMessage: state.appVersion.appVersionListError,
    //--------------------------Create-------------------------------
    isAppVersionCreateModalOpen: state.appVersion.isAppVersionCreateModalOpen,
    //--------------------------Edit---------------------------------
    isAppVersionEditModalOpen: state.appVersion.isAppVersionEditModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
    //--------------------------List---------------------------------
    getAppVersionList: (page, currentPage, searchVersionNo, searchNotes, searchReleasedDate, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder) =>
        dispatch(getAppVersionList(page, currentPage, searchVersionNo, searchNotes, searchReleasedDate, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder)),
    clearAppVersionListError: () => dispatch(clearAppVersionListError()),
    //--------------------------Create-------------------------------
    openCreateAppVersionModal: () => dispatch(openCreateAppVersionModal()),
    closeCreateAppVersionModal: () => dispatch(closeCreateAppVersionModal()),
    //--------------------------Edit---------------------------------
    setAppVersionDetails: (versionData) => dispatch(setAppVersionDetails(versionData)),
    openUpdateAppVersionModal: () => dispatch(openUpdateAppVersionModal()),
    closeUpdateAppVersionModal: () => dispatch(closeUpdateAppVersionModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppVersionList);